module.exports = __webpack_public_path__ + "img/view_first.adc4f273.png";